<div
  class="search-results-info"
  [class.d-none]="
    !isLoading && searchResult && searchResult.searchResultList && searchResult.searchResultList.length === 0
  "
>
  <div class="container d-none d-md-block search-results-info-component">
    <div class="row d-none d-md-block search-results-info-row">
      <div
        class="col vertical-spacing d-flex align-items-center"
        [innerHTML]="'searchResultsInfoString' | translate: { '0': getInterval(), '1': getTotalResults() } | safeHtml"
      ></div>
    </div>
  </div>
</div>
